import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ConfirmationPanel from './ConfirmationPanel';

interface ConfirmLeavingConversationProps {
    confirm: () => void;
    cancel: () => void;
}

function ConfirmLeavingConversation({
    confirm,
    cancel,
}: ConfirmLeavingConversationProps): React.ReactElement<ConfirmLeavingConversationProps> {
    const { t } = useTranslation(['conversationsFeature']);

    return (
        <ConfirmationPanel confirm={confirm} cancel={cancel}>
            <h3>{t('conversationsFeature:adminPanel.confirmation.leavingConversation.header')}</h3>
            <Trans
                i18nKey="conversationsFeature:adminPanel.confirmation.leavingConversation.body"
                components={{
                    p: <p />,
                    b: <b />,
                }}
            />
        </ConfirmationPanel>
    );
}

export default ConfirmLeavingConversation;
